import {authToken} from './script'

var instanceModal = null

function loadInstanceModal () {
  if (instanceModal === null) {
    var elem = document.querySelector('.modal.modal-login')
    instanceModal = M.Modal.init(elem, {
      dismissible: false
    })
  }
  return instanceModal
}

function showModalLogin () {
  loadInstanceModal().open()
}

function hideModalLogin () {
  loadInstanceModal().close()
}

function logOut () {
  delete localStorage['token']
  window.location.href = '/'
}

function clearPersistentLogin(){
  localStorage.removeItem('cpf')
  localStorage.removeItem('nascimento')
  localStorage.removeItem('oid')
}

export {logOut, showModalLogin, hideModalLogin, clearPersistentLogin}



// WEBPACK FOOTER //
// ./src/assets/js/scripts-login.js